import colors from 'distinct-colors';
import * as L from 'leaflet';
import React from 'react';
import * as ReactDOM from 'react-dom';
import 'leaflet-routing-machine';
import NetherlandsBoundedMap from '../../components/Map/NetherlandsBoundedMap';
import './../../addons/svg-marker';

// todo: check for future package update, this is a bug from leaflet
//  version: 1.3.4
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

interface Props {
  template: any;
  height: number;
  width: number;
}

interface State {
  width: number;
}

class RouteMapAlt extends React.Component<Props, State> {
  private readonly mapRef: any;
  assetLayerGroup: any;

  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.state = {
      width: this.props.width
    };
    this.assetLayerGroup = null;
  }

  componentDidMount() {
    this.assetLayerGroup = this.initMapControl();
    const width = this.getMapWidth();
    if (width !== undefined) {
      this.setState({ width });
    }
  }

  componentWillReceiveProps() {
    if (this.assetLayerGroup && this.mapRef.current) {
      let layers = this.mapRef.current.leafletElement._layers;
      for (let index in layers) {
        if (layers.hasOwnProperty(index)) {
          let layer = layers[index];
          if (layer._waypoints || layer._route || layer._latlngs) {
            this.mapRef.current.leafletElement.removeLayer(layer);
          }
        }
      }
    }
    this.assetLayerGroup = this.initMapControl();
  }

  getColorString(palette, index) {
    let color = palette[index]._rgb;
    return `rgb(${color[0]},${color[1]},${color[2]})`;
  }

  getMarker(waypoint, palette, order) {
    let customer = order.customer;
    let color = this.getColorString(palette, 0);
    return L.marker.svgMarker(waypoint.latLng, {
      order: order,
      iconOptions: {
        color: color,
        iconSize: [28, 38],
        originalColor: color,
        circleText: order.route_order + 1,
        circleRatio: 0.9,
        fontSize: 14
      }
    }).bindPopup(`<p>
        <strong>Adres:</strong><br>
        <span>${
          customer.first_name +
          ' ' +
          (customer.infix ? customer.infix + ' ' + customer.last_name : customer.last_name)
        }</span></br>
        <span>${customer.street_name + ' ' + customer.door_number}</span></br>
                <span>${customer.postal_code + ' ' + customer.city}</span></br>
        </p>`);
  }

  private initMapControl() {
    let number_of_colors = 3;
    let palette = colors({ count: number_of_colors, lightMin: 10, hueMin: 10, chromaMin: 70 });

    let customers = this.props.template.route_customers.filter(
      (routeCustomer) => routeCustomer.customer.lat !== null
    );

    const waypoints = customers.sort((a, b) => a.route_order - b.route_order);
    const mappedWaypoints = waypoints.map((routeCustomer) =>
      L.latLng(routeCustomer.customer.lat, routeCustomer.customer.lng)
    );

    
    // @ts-ignore
    const routing = L.Routing;

    let mapControl = routing.control({
      waypointMode: 'snap',
      router: new routing.OSRMv1({
        serviceUrl: process.env.REACT_APP_LOGISTICS_LEAFLET_URL
      }),
      lineOptions: {
        styles: [{ color: this.getColorString(palette, 0), opacity: 1, weight: 3 }]
      },
      plan: new routing.Plan(mappedWaypoints, {
        createMarker: (index, waypoint) => this.getMarker(waypoint, palette, waypoints[index]),
        geocoderClass: () => this.getColorString(palette, 0)
      })
    })
      .addTo(this.mapRef.current.leafletElement)
      .getPlan();

    return mapControl;
  }

  private getMapWidth(): number | undefined {
    const domNode = ReactDOM.findDOMNode(this.mapRef.current);
    if (domNode !== null && domNode instanceof Element) {
      const parent = domNode.parentNode;
      if (parent !== null && parent instanceof Element) {
        return parent.clientWidth;
      }
    }
    return undefined;
  }

  render = () => {
    return (
      <div>
        <NetherlandsBoundedMap
          center={[51.505, -0.09]}
          zoom={13}
          style={{ height: this.props.height, width: '100%' }}
          mapRef={this.mapRef}
        />
      </div>
    );
  };
}

export default RouteMapAlt;
